// extracted by mini-css-extract-plugin
module.exports = {"root":"IconInfo_root__1mTRK","fillColor":"IconInfo_fillColor__1C3Xx"};